<a class="btn btn-action btn-small btn-back" [routerLink]="{ cxRoute: 'rebateClaims' } | cxUrl">
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.rebateClaims' | cxTranslate }}
</a>

<section class="cx-section">
  <mat-card class="new-credit-claim">
    <h1 class="new-credit-claim__title">{{ 'rebateClaims.newClaim.newPriceSupportClaim' | cxTranslate }}</h1>
    <div class="new-credit-claim__section">
      <h4>{{ 'rebateClaims.newClaim.downloadNewForm' | cxTranslate }}</h4>
      <div class="new-credit-claim__section__content text-right">
        <p class="new-credit-claim__section__content__text">
          {{ 'rebateClaims.newClaim.downloadNewFormDescription' | cxTranslate }}
        </p>
        <a
          class="new-credit-claim__section__content__download-link"
          (click)="onDownloadFormClick()"
          target="_blank"
          title="{{ 'rebateClaims.newClaim.downloadNewForm' | cxTranslate }}"
        >
          <i [ngClass]="downloadSpinner ? 'fa-spinner fa-spin' : 'fa-download'" class="fa"></i>
          {{ 'rebateClaims.newClaim.downloadForm' | cxTranslate }}</a
        >
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="new-credit-claim__section new-credit-claim__section__upload">
      <h4>{{ 'rebateClaims.newClaim.uploadtitle' | cxTranslate }}</h4>
      <div class="new-credit-claim__section__content">
        <p class="new-credit-claim__section__content__text">
          {{ 'rebateClaims.newClaim.uploadNewFormDescription' | cxTranslate }}
          <br />
          <span class="new-credit-claim__warning">
            {{ 'rebateClaims.newClaim.fileFormatAdvise' | cxTranslate }}
          </span>
          <br />
          {{ 'rebateClaims.newClaim.monthSelectionExplained' | cxTranslate }}
        </p>

        <form [formGroup]="formUpload">
          <div class="row justify-content-end">
            <div class="col-auto col-md-3 col-lg-2 col-sm-3 col">
              <ng-select
                id="select-month"
                formControlName="selectedMonth"
                [items]="months"
                bindLabel="name"
                bindValue="name"
                placeholder="Calendar"
                class="new-credit-claim__section__ng-select-btn text-capitalize"
                (change)="updateUploadForm()"
              ></ng-select>
            </div>

            <div class="col-auto">
              <input
                id="same-address-input"
                class="new-credit-claim__section__content__upload"
                type="file"
                name="file-input"
                formControlName="fileInput"
                (change)="onUploadClaimForm($event.target.files)"
              />

              <label
                for="same-address-input"
                class="btn btn-primary default mb-0"
                [class.disabled]="!formUpload.valid"
                id="same-address-input-label"
              >
                <i [ngClass]="uploadSpinner ? 'fa-spinner fa-spin' : ''" class="fa"></i>
                {{ 'rebateClaims.newClaim.uploadForm' | cxTranslate }}</label
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </mat-card>
</section>
